export default {
    setReceiptLogs(state, receiptLogs) {
        state.receiptLogs = receiptLogs;
    },
    updateReceiptLogs(state, receiptLogs) {
        state.receiptLogs = [...state.receiptLogs, ...receiptLogs];
    },
    setTotalCount(state, total) {
        state.total = total;
    },
    setReceiptLogsPerPage(state, perPage) {
        state.receiptLogsPerPage = perPage;
    },
};
